/* iceberg-ui */
import { Flex, Text } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';

/* NPM */
import { motion } from 'framer-motion';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as WelcomeStepGraphicLight } from './WelcomeStepGraphic.svg';
import { ReactComponent as WelcomeStepGraphicDark } from './WelcomeStepGraphicDarkMode.svg';

const MotionWrapper = ({ children }) => {
    const variants = {
        hide: {
            opacity: 0,
            transition: {
                delay: 0.5,
                duration: 1,
                when: 'afterChildren'
            }
        },
        show: {
            opacity: 1,
            transition: {
                delay: 0,
                duration: 1,
                when: 'beforeChildren'
            }
        }
    };

    return (
        <motion.div
            variants={variants}
            initial="hide"
            animate="show"
            style={{ height: '100%', width: '100%' }}
        >
            {children}
        </motion.div>
    );
};

export const RightWelcomePanel = ({ error }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    const WelcomeStepFeatureFlag =
        userTheme === 'dark' ? (
            <WelcomeStepGraphicDark
                alt={t('anmTrial.welcome.graphic')}
                style={{ height: '100%', width: '100%' }}
                data-testid="welcomeStepGraphic_image"
            />
        ) : (
            <WelcomeStepGraphicLight
                alt={t('anmTrial.welcome.graphic')}
                style={{ height: '100%', width: '100%' }}
                data-testid="welcomeStepGraphic_image"
            />
        );

    return (
        <Flex
            alignItems="center"
            data-testid="rightWelcomePanel"
            flexDirection="column"
            height="100%"
            justifyContent="center"
            position="relative"
        >
            <Flex justifyContent="center" width="100%" maxHeight="65%">
                <MotionWrapper key="rightWelcomePanelImg">
                    {WelcomeStepFeatureFlag}
                </MotionWrapper>
            </Flex>
            {!error && (
                <Text
                    color={theme.palette.anmTrial.titleTextColor}
                    fontSize={2}
                    maxHeight="35%"
                    mt={[5, 5, '10%']}
                    textAlign="center"
                    width="70%"
                >
                    {t('anmTrial.welcome.graphic')}
                </Text>
            )}
        </Flex>
    );
};
